// this file gets replaced with the real value during the build
const Version = '6.5.0';

export { Version as default };
